<template>
  <div id="form-menu">
    <b-loading
      :active.sync="loader"
      :can-cancel="false"
      :is-full-page="isFullPage"
      id="loadingForm"
    ></b-loading>
    <span class="text bold-strong size-18">Diligencia los siguientes campos</span>
    <div class="inputs">
      <b-field
        :message="errors.first('nameForm')"
        :type="{'is-danger': errors.has('nameForm')}"
        label="Nombres*"
      >
        <b-input
          id="nameForm"
          name="nameForm"
          type="text"
          v-model="data.name"
          v-validate="'required'"
        ></b-input>
      </b-field>
      <div class="input-duo">
        <b-field
          :message="errors.first('typeId')"
          :type="{'is-danger': errors.has('typeId')}"
          class="min-input"
          label="Tipo de id*"
        >
          <b-select
            id="typeId"
            name="typeId"
            placeholder="Tipo"
            v-model="data.typeDocument"
            v-validate="'required'"
          >
            <option>CC</option>
            <option>CE</option>
            <option>MIT</option>
          </b-select>
        </b-field>
        <b-field
          :message="errors.first('idInde')"
          :type="{'is-danger': errors.has('idInde')}"
          label="Identificación*"
          style="width: 100%;"
        >
          <b-input
            id="idInde"
            name="idInde"
            v-model="data.identityDocument"
            v-validate="'required|regex:^[a-zA-Z0-9]*$'"
          ></b-input>
        </b-field>
      </div>
      <b-field
        :message="errors.first('email')"
        :type="{'is-danger': errors.has('email')}"
        label="Email*"
      >
        <b-input id="email" name="email" type="email" v-model="data.email" v-validate="'required'"></b-input>
      </b-field>
      <b-field
        :message="errors.first('phone')"
        :type="{'is-danger': errors.has('phone')}"
        label="Teléfono"
      >
        <b-input id="phone" name="phone" v-model="data.phone" v-validate="'required'"></b-input>
      </b-field>
      <b-field
        :message="errors.first('BranchSede')"
        :type="{'is-danger': errors.has('BranchSede')}"
        label="Seleccione sede"
        v-if="params.isBranch == 1"
      >
        <b-select
          id="BranchSede"
          name="BranchSede"
          placeholder="Sede"
          v-model="sedeId"
          v-validate="'required'"
        >
          <option
            :key="index + branch.id"
            :value="branch.vendorIdParent"
            v-for=" (branch,index) in branchSede"
          >{{branch.displayName}}</option>
        </b-select>
      </b-field>
      <div class="temp">
        <span class="text bold-strong size-12">Temperaturaº</span>
        <span
          class="text size-10"
        >Digita en el siguiente campo la temperatura corporal (Grados centígrados)</span>
        <input class="input-temp" placeholder="Temp (35)" type="text" v-model="data.temperature" />
      </div>
      <div v-if="params.questionCovid == 1">
        <span
          class="t-question"
        >¿Ha estado en contacto con personas con infección respiratoria aguda o personas diagnosticadas con COVID-19?</span>
        <div class="questions">
          <div
            :class="{'active': data.question1 == 1 }"
            @click="(data.question1 == 1) ? data.question1 = null : data.question1 = 1"
            class="input-question left"
          >
            <span class="t-input">Si</span>
          </div>
          <div
            :class="{'active': data.question1 == 0 }"
            @click="(data.question1 == 0) ? data.question1 = null : data.question1 = 0"
            class="input-question right"
          >
            <span class="t-input">No</span>
          </div>
        </div>
      </div>
      <div v-if="params.questionCovid == 1">
        <span
          class="t-question"
        >¿Presenta alguno de los siguientes síntomas: dolor de garganta, fiebre mayor a 38 grados, tos seca y persistente, dificultad para respirar, dolor muscular de cabeza y/o de articulaciones?</span>
        <div class="questions">
          <div
            :class="{'active': data.question2 == 1 }"
            @click="(data.question2 == 1) ? data.question2 = null : data.question2 = 1"
            class="input-question left"
          >
            <span class="t-input">Si</span>
          </div>
          <div
            :class="{'active': data.question2 == 0 }"
            @click="(data.question2 == 0) ? data.question2 = null : data.question2 = 0"
            class="input-question right"
          >
            <span class="t-input">No</span>
          </div>
        </div>
      </div>
    </div>
    <div class="terms">
      <label class="checkbox__label" for="customCheckbox1">
        <div class="checkbox__group">
          <input
            class="checkbox__input"
            hidden
            id="customCheckbox1"
            name="terminos"
            type="checkbox"
            v-model="radio"
            v-validate="'required'"
          />
          <span :class="{'active': radio == true}" class="checkbox__checked"></span>
        </div>
      </label>
      <span class="text size-10">
        "Al dar clic en "Guardar" declara que conoce y acepta
        <span
          @click="dataInfoormation()"
          class="text size-11 bold cursor"
          v-if="params.vendorId == 130 || params.vendorId == 141 || params.vendorId == 139 || params.vendorId == 142"
        >el tratamiento de datos personales</span>
        <span v-else>el tratamiento de datos personales</span> previamente informado y al enviar este formato a Precompro acepta nuestros
        <span
          @click="terms()"
          class="text size-11 bold cursor"
        >Términos y condiciones y la Política de Privacidad*</span>"
      </span>
    </div>
    <span
      :key="'error-'+index"
      class="text size-12 red"
      v-for="(error,index) in errors.collect('terminos')"
    >Debe aceptar términos y condiciones</span>
    <div @click="sendForm(data)" class="btn-save">
      <span class="text bold-strong white size-18">Guardar</span>
    </div>
  </div>
</template>
<script>
import datos from '@/components/menuDigital/Terminos/tratamientoDatos';
import terms from '@/components/Terms';
import whiteLabelTypes from '@/store/types/whiteLabel';
import globalTypes from '@/store/types/global';
import { mapGetters } from 'vuex';
export default {
  data () {
    return {
      data: {
        name: null,
        typeDocument: null,
        identityDocument: null,
        email: null,
        phone: null,
        temperature: 0,
        vendorId: null,
        people: 1,
        referrer: 'Walk-In',
        sendText: false,
        question1: null,
        question2: null
      },
      loader: false,
      isFullPage: true,
      radio: false,
      branchSede: [],
      sedeId: null
    };
  },
  methods: {
    sendForm (data) {
      this.$validator.validateAll().then(result => {
        if (this.params.isBranch === 1) {
          data.sedeId = this.sedeId;
        }
        data.vendorId = this.encrypt(this.vendor.id);
        if (result === true) {
          this.loader = true;
          this.$store.dispatch({ type: 'whiteLabel:formMenuDigital', data })
            .then(() => {
              this.loader = false;
              this.$emit('activeView', 3);
            })
            .catch(() => {
              this.loader = false;
              console.log('error');
            });
        }
      });
    },
    dataInfoormation () {
      this.$buefy.modal.open({
        parent: this,
        component: datos,
        hasModalCard: true
      });
    },
    terms () {
      this.$buefy.modal.open({
        parent: this,
        component: terms,
        hasModalCard: true,
        props: {
          fecha: new Date()
        }
      });
    }
  },
  computed: {
    ...mapGetters({
      vendorUrl: globalTypes.getters.vendorUrl,
      branch: whiteLabelTypes.getters.branch
    })
  },
  mounted () {
    if (this.params.isBranch === 1) {
      this.$store.dispatch({ type: 'whiteLabel:branch', data: { url: this.vendorUrl } }).then(response => {
        this.branchSede = response;
      }).catch(() => {

      });
    }
    if (this.params.bannerActiveMenuDigital === 1) {
      this.$store.commit('whiteLabel:setMenuIdBanner', 'formulario');
    }
  }
};
</script>
<style lang="scss">
#form-menu {
  display: flex;
  flex-direction: column;
  padding: 30px;
  align-items: center;
  .text {
    color: black;
    &.size {
      &-10 {
        font-size: 10px;
      }
      &-11 {
        font-size: 11px;
      }
      &-12 {
        font-size: 12px;
      }
    }
    &.bold {
      font-weight: bold;
    }
    &.cursor {
      cursor: pointer;
    }
    &.red {
      color: red;
    }
  }
  .inputs {
    margin-top: 30px;
  }
  .label {
    font-size: 12px;
    font-weight: 600;
  }
  .input {
    border-radius: 9px;
    height: 32px;
    box-shadow: inherit;
    border-color: rgba(3, 15, 52, 0.5);
    &:focus {
      border-color: rgba(3, 15, 52, 0.5);
    }
    &:active {
      border-color: rgba(3, 15, 52, 0.5);
    }
  }
  .select select {
    border-radius: 9px;
    height: 32px;
    box-shadow: inherit;
    border-color: rgba(3, 15, 52, 0.5);
  }
  .input-duo {
    display: flex;
    &.center {
      display: flex;
      align-items: flex-end;
    }
  }
  .btn-save {
    border-radius: 6px;
    margin-top: 30px;
    width: 80%;
    background: #06111b;
    height: 37px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .field {
    &.min-input {
      margin-right: 10px;
      .select select {
        width: 100px;
      }
    }
  }
  .temp {
    display: flex;
    flex-direction: column;
    .input-temp {
      margin-top: 10px;
      width: 80px;
      font-size: 13px;
      padding-left: 7px;
      height: 30px;
      border-radius: 6px;
      border: 1px solid rgba(3, 15, 52, 0.5);
    }
  }
  .terms {
    display: flex;
    max-width: 400px;
    margin-top: 10px;
    .checkbox {
      &__label {
        margin: 0 5px;
        cursor: pointer;
      }

      &__group {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 20px;
        height: 20px;
        background: transparent;
        border: 2px solid black;
        border-radius: 5px;
      }

      &__input:checked + &__checked {
        opacity: 1;
      }

      &__checked {
        content: "";
        width: 4px;
        height: 10px;
        margin-top: -2px;
        border-right: 2px solid black;
        border-bottom: 2px solid black;
        opacity: 0;
        transform: rotate(30deg);
        transition: 0.2s;
        &.active {
          opacity: 1;
        }
      }
    }
  }
  .questions {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 0;
    .input-question {
      box-shadow: 0 1px 7px rgba(0, 0, 0, 0.3);
      width: 30px;
      height: 25px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      &.left {
        border-radius: 10px 0 0 10px;
      }
      &.right {
        border-radius: 0 10px 10px 0;
      }
      &.active {
        background: #14274e;
        color: #ffffff;
      }
      .t-input {
        font-size: 13px;
        font-weight: 600;
      }
    }
  }
  .t-question {
    font-size: 12px;
    font-weight: 400;
    max-width: 600px;
  }
}
#loadingForm {
  background: #000;
  opacity: 0.5;
}
</style>
